// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"5b452199","347":"9b63de14","551":"b75af06d","586":"b25be367","828":"13e76792"}[chunkId] + ".chunk.js";
};